module.exports = __webpack_public_path__ + "img/truck2.7e03cdd8.svg";